// * If a new provider is added, the handleSocialSignIn function should be updated to include the new provider query.

import { fetchData, generateMinifiedQuery } from 'src/helpers/graphQLHelper'
import { SocialLoginProvider } from 'src/types/SocialLoginType'

export const GoogleLoginQuery = `
mutation googleLogin($token: String!, $deviceId: String!) {
    googleLogin(token: $token, deviceId: $deviceId) {
        success
        v2ManagementApiEnabled
        v2VodManagementApiEnabled
        isTwoFactorOnLogin
        obscureMobileNumber
        username
        accessToken
        refreshToken
    }
}`
export const MicrosoftLoginQuery = `
mutation microsoftLogin($token: String!, $deviceId: String!) {
    microsoftLogin(token: $token, deviceId: $deviceId) {
        success
        v2ManagementApiEnabled
        v2VodManagementApiEnabled
        isTwoFactorOnLogin
        obscureMobileNumber
        username
        accessToken
        refreshToken
    }
}`

export async function handleSocialSignIn(oAuthToken: string, provider: SocialLoginProvider, deviceId: string) {
  const query = provider === 'google' ? GoogleLoginQuery : MicrosoftLoginQuery
  const payload = {
    graphQLReq: {
      query: generateMinifiedQuery(query),
      variables: {
        token: oAuthToken,
        deviceId,
      },
    },
  }
  const data = await fetchData(payload)
  if (data instanceof Error) return data
  if (provider === 'google') {
    return data.googleLogin
  }
  if (provider === 'microsoft') {
    return data.microsoftLogin
  }
}